import { Box, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import {
  FaHashnode,
  FaGithub,
  FaLinkedinIn,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";

const cyan = "#CFFAFE";

export default function AboutMe() {
  return (
    <Box>
      <Box>
        <Typography
          variant="h4"
          sx={{ fontFamily: "monospace", pb: 1, color: cyan }}
          gutterBottom
        >
          Amirah Nasihah👋
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            width: { xs: "100%", md: "70%", sm: "80%" },
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            margin: "10px auto",
          }}
        >
          I didn&apos;t have access to formal education in the field. So, I{" "}
          <Typography
            variant="subtitle1"
            sx={{
              textDecoration: "underline",
              color: cyan,
              fontWeight: "semibold",
            }}
            component="span"
          >
            taught myself how to code
          </Typography>{" "}
          and started learning everything I could about technology development.
        </Typography>
      </Box>

      {/* SOCIAL */}
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ gap: 1 }}
      >
        <IconButton
          aria-label="twitter"
          href="https://twitter.com/amrhnshh"
          target="_blank"
          rel="noreferrer"
        >
          <FaXTwitter color={cyan} />
        </IconButton>
        <IconButton
          aria-label="linkedin"
          href="http://www.linkedin.com/in/amirahnasihah"
          target="_blank"
          rel="noreferrer"
        >
          <FaLinkedinIn color={cyan} />
        </IconButton>
        <IconButton
          aria-label="github"
          href="https://github.com/amirahnasihah"
          target="_blank"
          rel="noreferrer"
        >
          <FaGithub color={cyan} />
        </IconButton>
        <IconButton
          aria-label="hashnode"
          href="https://hashnode.com/@amirahnasihah"
          target="_blank"
          rel="noreferrer"
        >
          <FaHashnode color={cyan} />
        </IconButton>
        <IconButton
          aria-label="hashnode"
          href="https://www.youtube.com/@amirahnasihah/videos"
          target="_blank"
          rel="noreferrer"
        >
          <FaYoutube color={cyan} />
        </IconButton>
      </Grid>
    </Box>
  );
}
